import { FilterSettings } from '@/types';

// Loads slicers for each visual
export const getSlicerStates = async (visuals): Promise<FilterSettings[]> => {
  let visualSlicerFilters: Array<FilterSettings> = [];
  if (visuals && visuals.length > 0) {
    const promises = [];
    visuals.forEach((visual) => {
      promises.push(visual.getSlicerState());
    });
    const values = await Promise.all(promises);
    for (let i = 0; i < visuals.length; i++) {
      visualSlicerFilters.push({
        title: visuals[i].title,
        filters: values[i].filters,
      });
    }
  }
  return visualSlicerFilters;
};
